import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { NotificationsActive } from "@mui/icons-material";

export const isPostPayload = (text) => {
  if (!text || typeof text !== 'string') return null;
  const trimmed = text.trim();
  if (!trimmed.startsWith('{')) return null;
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed && parsed.type === 'shared_post') return parsed;
    return null;
  } catch (e) {
    return null;
  }
};

const SharedPostCard = ({ text, isMe }) => {
  const payload = isPostPayload(text);
  if (!payload) return null;

  const {
    mediaUrl = '',
    title = 'Publicación de la comunidad',
    authorName = 'Hitpoly',
    authorAvatar = '',
    targetUrl = '',
  } = payload;

  const linkColor = isMe ? '#fff' : '#3B207F';
  const footerBg = isMe ? 'rgba(255,255,255,0.08)' : '#f0f2f5';
  const titleColor = isMe ? '#fff' : '#1a1a1a';

  const openPost = (e) => {
    if (e) e.preventDefault();
    window.open(targetUrl, '_blank');
  };

  return (
    <Box
      sx={{
        maxWidth: 360,
        width: '100%',
        borderRadius: 2,
        overflow: 'hidden',
        bgcolor: isMe ? 'rgba(255,255,255,0.04)' : '#fff',
        border: isMe ? 'none' : '1px solid #e4e6eb',
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
      }}
    >
      {mediaUrl ? (
        <Box
          component="img"
          src={mediaUrl}
          alt={title}
          onClick={openPost}
          sx={{
            width: '100%',
            maxHeight: 280,
            objectFit: 'cover',
            display: 'block',
            bgcolor: '#e4e6eb',
            cursor: 'pointer',
          }}
        />
      ) : (
        <Box
          onClick={openPost}
          sx={{
            width: '100%',
            height: 140,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: isMe ? 'rgba(255,255,255,0.06)' : '#e4e6eb',
            cursor: 'pointer',
          }}
        >
          <NotificationsActive sx={{ fontSize: 48, color: isMe ? 'rgba(255,255,255,0.5)' : '#b0b3b8' }} />
        </Box>
      )}

      <Box
        onClick={openPost}
        sx={{
          px: 1.5,
          py: 1.2,
          bgcolor: footerBg,
          borderTop: isMe ? '1px solid rgba(255,255,255,0.12)' : '1px solid #e4e6eb',
          cursor: 'pointer',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 700, color: titleColor, fontSize: '0.82rem', mb: 0.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Avatar src={authorAvatar} sx={{ width: 16, height: 16 }}>
            {authorName?.charAt(0)}
          </Avatar>
          <Typography variant="caption" sx={{ fontWeight: 700, color: linkColor }}>
            {authorName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SharedPostCard;